import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getRequestTypesByClient } from '../../claimRequestType/api/claimRequestTypeApi';

type QueryFnType = typeof getRequestTypesByClient;

type UseRequestTypesSelectOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useRequestTypesSelect = ({ config = {} }: UseRequestTypesSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['useRequestTypesSelect', i18n.language],
        queryFn: () => getRequestTypesByClient(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
}; 